import { AdminClassroomLayout } from "@/pages/admin/AdminClassroomLayout";
import { StudentHomeworkListPage } from "@/pages/teacher/StudentHomeworkListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/classrooms/$classroomId/students/$studentId/homework/"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId, studentId } = Route.useParams();
  return (
    <AdminClassroomLayout>
      <StudentHomeworkListPage classroomId={classroomId} studentId={studentId} scope="admin" />
    </AdminClassroomLayout>
  );
}
